"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngleUnits = ["deg", "rad"];
exports.Dimension = ["width", "height"];
exports.Dimensions = ["width", "height", "both"];
exports.Direction = ["clock", "anticlock"];
exports.FontStyle = ["normal", "italic", "bold"];
exports.LatLon = ["lat", "lon"];
exports.LineCap = ["butt", "round", "square"];
exports.LineJoin = ["miter", "round", "bevel"];
exports.Location = ["above", "below", "left", "right"];
exports.LegendLocation = ["top_left", "top_center", "top_right", "center_left", "center", "center_right", "bottom_left", "bottom_center", "bottom_right"];
exports.Orientation = ["vertical", "horizontal"];
exports.RenderLevel = ["image", "underlay", "glyph", "annotation", "overlay"];
exports.RenderMode = ["canvas", "css"];
exports.Side = ["left", "right"];
exports.SpatialUnits = ["screen", "data"];
exports.StartEnd = ["start", "end"];
exports.TextAlign = ["left", "right", "center"];
exports.TextBaseline = ["top", "middle", "bottom", "alphabetic", "hanging", "ideographic"];
exports.DistributionTypes = ["uniform", "normal"];
exports.TransformStepModes = ["after", "before", "center"];
exports.SizingMode = ["stretch_both", "scale_width", "scale_height", "scale_both", "fixed"];
